import EditAvatar from '@/components/EditAvatar'
import { updateOrganization, deleteOrganization } from '@/services/organization/organization.service'
import { useRequest } from 'ahooks'
import { Button, Col, Form, Input, Row, Typography, List, Modal } from 'antd'
import classnames from 'classnames'
import React, { memo, useContext, useEffect } from 'react'
import { OrganizationContext } from '../..'
import { useNavigate } from 'react-router'
import styles from './index.module.less'

const { Title } = Typography

export default memo(function OrganizationSettingGeneral() {
  const [form] = Form.useForm()
  const { orgRefresh } = useContext(OrganizationContext)
  const orgData = useContext(OrganizationContext).orgData!
  const navigate = useNavigate()

  const { run } = useRequest(updateOrganization, {
    manual: true,
    onSuccess: () => {
      orgRefresh()
    }
  })

  useEffect(() => {
    form.setFieldsValue(orgData)
  }, [orgData])

  return (
    <div className={classnames('border p-2', styles.container)}>
      <Row gutter={16} className={'py-2'}>
        <Col span={14}>
          <Form
            form={form}
            autoComplete='off'
            layout='vertical'
            onFinish={(values) => {
              run(orgData.id, values)
            }}
          >
            <Form.Item label='Name' name='name' rules={[{ required: true, message: 'Please enter Name' }]}>
              <Input placeholder='Enter your name' />
            </Form.Item>

            <Form.Item
              label='Contact email'
              name='contactEmail'
              rules={[
                { required: true, message: 'Please enter email address' },
                { type: 'email', message: 'Invalid email format' }
              ]}
            >
              <Input type='email' placeholder='Enter email address' />
            </Form.Item>

            {/*<Form.Item*/}
            {/*  label="Billing email(private)"*/}
            {/*  name="billingEmail"*/}
            {/*  rules={[*/}
            {/*    { required: true, message: 'Please enter billing email address' },*/}
            {/*    { type: 'email', message: 'Invalid email format'}*/}
            {/*  ]}*/}
            {/*>*/}
            {/*  <Input*/}
            {/*    type="email"*/}
            {/*    placeholder="Enter billing email address"*/}
            {/*  />*/}
            {/*</Form.Item>*/}

            <Form.Item label='Description' name='description' rules={[]}>
              <Input.TextArea rows={3} placeholder='Add some description of the organization' />
            </Form.Item>

            <Form.Item>
              <Button htmlType='submit' type='primary'>
                Save
              </Button>
            </Form.Item>
          </Form>
        </Col>
        <Col span={10}>
          <EditAvatar
            metaData={{}}
            avatarSize={160}
            name={orgData.name}
            value={orgData.avatar}
            onChange={(avatar) => {
              run(orgData.id, { avatar })
            }}
          />
        </Col>
      </Row>

      <div className={'mt-2'}>
        <Title level={4}>Danger Zone</Title>

        <List bordered>
          <List.Item
            actions={[
              <Button
                danger
                key='delete'
                onClick={() => {
                  Modal.confirm({
                    content: 'Are you sure to delete?',
                    onOk: async () => {
                      await deleteOrganization(orgData.id)
                      navigate('/list')
                    }
                  })
                }}
              >
                Delete this organization
              </Button>
            ]}
          >
            <List.Item.Meta
              title='Delete this organization'
              description='Once you delete a organization, there is no going back. Please be certain.'
            />
          </List.Item>
        </List>
      </div>
    </div>
  )
})
